import React, { useRef, useState } from "react";
import { UploadCloud, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import AuthImage from "./AuthImage";

// value: string path (single) OR array of paths (multiple)
export default function FileUpload({ multiple = false, value, onChange, label, testid }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);
  const paths = multiple ? (value || []) : value ? [value] : [];

  const handleFiles = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const uploaded = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd);
        uploaded.push(data.path);
      }
      onChange(multiple ? [...(value || []), ...uploaded] : uploaded[0]);
      toast.success(`Uploaded ${uploaded.length} file(s)`);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (p) => onChange(multiple ? (value || []).filter((x) => x !== p) : "");

  return (
    <div className="space-y-2">
      {label && <span className="text-sm text-[#D2CAB2]">{label}</span>}
      <button
        type="button"
        data-testid={testid}
        onClick={() => inputRef.current?.click()}
        className="w-full rounded-xl border-2 border-dashed border-white/20 hover:border-[#C9A227] bg-[#0c0c0d] py-6 flex flex-col items-center justify-center text-[#948C79] transition-colors"
      >
        {busy ? <Loader2 className="h-6 w-6 animate-spin text-[#C9A227]" /> : <UploadCloud className="h-6 w-6" />}
        <span className="mt-2 text-sm">{busy ? "Uploading…" : `Click to upload ${multiple ? "images" : "an image"}`}</span>
        <span className="text-xs text-[#7E7663]">PNG, JPG, WEBP up to 8MB</span>
      </button>
      <input ref={inputRef} type="file" accept="image/*" multiple={multiple} className="hidden" onChange={(e) => handleFiles(e.target.files)} />
      {paths.length > 0 && (
        <div className="flex flex-wrap gap-3 pt-1">
          {paths.map((p) => (
            <div key={p} className="relative group">
              <AuthImage path={p} alt="upload" className="h-20 w-20 rounded-lg object-cover border border-white/10" />
              <button type="button" onClick={() => remove(p)} className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-black text-white flex items-center justify-center opacity-90 hover:bg-red-600">
                <X className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
